import React, { useState, useEffect } from "react";
import { JsonApiAdapter } from "commons/JsonApiAdapter";
import { BugsnagAdapter } from "commons/BugsnagAdapter";
import AhoyEvent from "shared/ahoy_event";
import AhoyTracker from "shared/ahoy_tracker";
import WatchPlaylistPicker from "components/desktop/watch/WatchPlaylist/WatchPlaylistPicker";
import WatchPlaylistEpisodeList from "components/desktop/watch/WatchPlaylist/WatchPlaylistEpisodeList";

export default function WatchPlaylist({ videoId, channelId }) {
  const [seasonData, setSeasonData] = useState([]);
  const [selectedPlaylistId, setSelectedPlaylistId] = useState(null);
  const [contentType, setContentType] = useState(null);
  const [contentData, setContentData] = useState(null);

  useEffect(() => {
    const playlistPath = `/videos/${videoId}/content_profile?channel_id=${channelId}`;

    JsonApiAdapter.fetchApi(playlistPath)
      .then(handleResponse)
      .catch((e) => {
        BugsnagAdapter.notify("WatchPlaylist::getContentProfilePlaylists", e);
      });
  }, []);

  function handleResponse(responseData) {
    setSelectedPlaylistId(responseData.data.meta.selected_playlist.id);
    setSeasonData((seasonData) => seasonData.concat(responseData.included));
    setContentType(responseData.meta.actual_type);
    setContentData(responseData.data);
  }

  function onSelectPlaylist(e) {
    setSelectedPlaylistId(e.target.value);
  }

  function renderPicker() {
    if (contentType != null && contentType === "content_profile") {
      return (
        <WatchPlaylistPicker
          seasonData={seasonData}
          onSelectPlaylist={onSelectPlaylist}
          selectedPlaylistId={selectedPlaylistId}
        />
      );
    }
  }

  function sendAhoyImpression() {
    const ahoyTitle = "WATCHPAGE";
    const ahoyImpressionProps = {
      action: 'impression',
      source_content_id: parseInt(videoId),
      section: 'playlist',
      feature: contentType
    };
    let eventTitle = AhoyTracker.getEventTitle(ahoyTitle);
    AhoyEvent.send(eventTitle, ahoyImpressionProps);
  }

  if (contentData) {
    sendAhoyImpression();
    return (
      <div className="watch-playlist">
        <div className="watch-playlist-header">
          <div className="watch-playlist-header__image-container">
            <div className="watch-playlist-header__image-placeholder">
              <img
                className="watch-playlist-header__image"
                src={contentData.attributes.image_portrait_url}
              />
            </div>
          </div>
          <div className="watch-playlist-header__info">
            <span className="watch-playlist-header__title">
              {contentData.attributes.title}
            </span>
          </div>
        </div>
        <div className="watch-playlist-list-wrapper">
          {renderPicker()}

          {selectedPlaylistId != null &&
            seasonData.map((seasonData) => (
              <WatchPlaylistEpisodeList
                key={seasonData.id}
                playlistId={seasonData.id}
                selectedPlaylistId={selectedPlaylistId}
                videoId={videoId}
                seasonData={seasonData}
                contentType={contentType}
              />
            ))}
        </div>
      </div>
    );
  } else {
    return <React.Fragment />;
  }
}
